import type { ProjectUndeliveredFamilies } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import {
  listUndeliveredFamilies,
  undeliveredFamiliesTooltip,
  worstUndeliveredReasonMeta,
} from './undeliveredFamilyMeta';

/**
 * Compact "this project still owes Oil" marker for table cells (DR-2855).
 * Renders nothing when nothing is owed, so it can sit unconditionally beside
 * the existing finalization badge. Detail lives in the native `title` tooltip —
 * there is no tooltip primitive in `catalyst/`.
 */
export function UndeliveredBadge({ families }: { families?: ProjectUndeliveredFamilies | null }) {
  const entries = listUndeliveredFamilies(families);
  const worst = worstUndeliveredReasonMeta(entries);

  if (!worst) {
    return null;
  }

  return (
    <span title={undeliveredFamiliesTooltip(entries)}>
      <Badge color={worst.color}>Undelivered · {entries.length}</Badge>
    </span>
  );
}
